const calendarChipsToggles = {
  actions: 'AÇÕES',
  services_performed: 'SERVIÇOS REALIZADOS',
  services_to_be_performed: 'SERVIÇOS A REALIZAR / VENCIDOS',
  maintenances: 'MANUTENÇÕES',
  future_services: 'SERVIÇOS FUTUROS',

};

export default calendarChipsToggles;
